module.exports = __webpack_public_path__ + "static/family-f1232ec12410f296f47b36ac5aa54c61.jpg";